export default "__VITE_ASSET__35020609__"